/**
 * データ識別ラベルを右サイドバーに移動します。
 *
 * Updated: 2023/09/22
 *
 * @param {Object} options
 * @param {String} [options.insertBefore='#basename-field'] - 挿入する前のセレクター。
 * @param {String} [options.linkedField=null] - データ識別ラベルにリンクするフィールドのセレクター。
 *
 * @example
 * mtapp.dataLabelCustomize({ insertBefore: '#some-id', linkedField: '#another-id' });
 */
export function dataLabelCustomize(options) {
    const defaults = {
        insertBefore: '#basename-field',
        linkedField: null
    };
    const op = { ...defaults, ...options };

    const dataLabel = document.getElementById('data_label');
    const dataLabelField = document.getElementById('data_label-field');

    if (op.insertBefore) {
        const insertBeforeElement = document.querySelector(op.insertBefore);
        if (dataLabelField && insertBeforeElement) {
            insertBeforeElement.parentNode.insertBefore(dataLabelField, insertBeforeElement);
        }
    }

    if (op.linkedField !== null) {
        const linkedFieldElement = document.querySelector(op.linkedField);
        if (linkedFieldElement) {
            linkedFieldElement.addEventListener('change', function () {
                dataLabel.value = this.value;
            });
        }
    }
}
